import Hero from '../components/Hero';
import Services from '../components/Services';
import Gallery from '../components/Gallery';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const Home = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll au haut de la page à chaque changement d'URL
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <Helmet>
        <title>Placof Décor | Décoration Intérieure & Placoplâtre à Sfax</title>
        <meta
          name="description"
          content="Placof Décor est votre spécialiste en décoration intérieure, faux plafonds et placoplâtre à Sfax. Découvrez notre galerie de réalisations et nos services sur mesure."
        />
        <meta name="keywords" content="placoplatre Sfax, décoration intérieure Sfax, faux plafond, design mural, entreprise décoration Tunisie" />

        {/* Balises Open Graph (Facebook, LinkedIn, etc.) */}
        <meta property="og:title" content="Placof Décor | Décoration Intérieure & Placoplâtre à Sfax" />
        <meta property="og:description" content="Spécialiste en décoration intérieure, faux plafonds et placoplâtre à Sfax." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://placofdecor.tn" />
        <meta property="og:image" content="https://placofdecor.tn/logo.png" />

        <link rel="canonical" href={`https://placofdecor.tn${pathname}`} />

        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "LocalBusiness",
              "name": "Placof Décor",
              "image": "https://placofdecor.tn/logo.png",
              "description": "Spécialiste en décoration intérieure, faux plafonds et placoplâtre à Sfax.",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Route de tunis km 23",
                "addressLocality": "Sfax",
                "addressRegion": "Tunisie",
                "postalCode": "3043"
              },
              "telephone": "+21697286007",
              "openingHours": "Mo-Fr 08:00-18:00",
              "priceRange": "$$",
              "url": "https://placofdecor.tn"
            }
          `}
        </script>
      </Helmet>
      <Hero />
      <Services />
      <Gallery />
      {/* <Testimonials />
      <ContactForm /> */}
    </>
  );
};

export default Home;